import { checkoutDurationMs, wasCheckoutWarmupRequested } from './checkout-warmup.js';
import type { EmbeddedCheckoutStage } from './panels/embedded-checkout-dialog-lit.js';
import type { MapAnalyticsTrack } from '../shared/analytics-schema.js';
export const CHECKOUT_REQUEST_TIMEOUT_MS = 30_000;

export function checkoutDeadline<T>(promise: Promise<T>, milliseconds = CHECKOUT_REQUEST_TIMEOUT_MS): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('Checkout request timed out')), milliseconds);
    promise.then(value => { clearTimeout(timer); resolve(value); }, error => { clearTimeout(timer); reject(error); });
  });
}

export function createCheckoutTiming(track: MapAnalyticsTrack, props: Record<string, string>,
  updateStage: (value: EmbeddedCheckoutStage) => void) {
  const startedAt = performance.now();
  const durations: Record<string, string> = {};
  let lastStep: EmbeddedCheckoutStage = 'preparing_export';
  let closedReported = false;
  let stageStartedAt = startedAt;
  const stage = (value: EmbeddedCheckoutStage) => { lastStep = value; stageStartedAt = performance.now(); updateStage(value); };
  const report = (outcome: string, extra: Record<string, string> = {}) => {
    if (outcome === 'closed' && closedReported) return;
    if (outcome === 'closed') closedReported = true;
    track('pro_checkout_performance', {
      ...props, ...durations, outcome, last_step: lastStep, timing_version: '2',
      last_step_ms: checkoutDurationMs(performance.now() - stageStartedAt),
      warmup: wasCheckoutWarmupRequested() ? 'requested' : 'cold',
      total_ms: checkoutDurationMs(performance.now() - startedAt), ...extra,
    });
  };
  const onPageHide = () => { if (!closedReported) report('page_hidden'); };
  globalThis.addEventListener?.('pagehide', onPageHide, { once: true });
  return { durations, stage, report, dispose: () => globalThis.removeEventListener?.('pagehide', onPageHide) };
}

export function checkoutServerTiming(header: string | null) {
  const durations: Record<string, string> = {};
  for (const metric of (header ?? '').split(',')) {
    const match = /^\s*(total|stripe|auth|prepare|rate_limit)\s*;\s*dur=([0-9]+(?:\.[0-9]+)?)\s*$/.exec(metric);
    if (match && Number.isFinite(Number(match[2]))) {
      durations[`server_${match[1]}_ms`] = checkoutDurationMs(Number(match[2]));
    }
  }
  return durations;
}
